/* eslint-disable max-len */

const ViewCartIcon = () => (
  <svg
    aria-hidden
    enableBackground='new 0 0 30 29'
    height='36'
    id='Layer_1'
    version='1.1'
    viewBox='-10 -11 50 50'
    width='36'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <circle cx='12.5' cy='24.7' r='1.9' />
      <circle cx='19.9' cy='24.7' r='1.9' />
      <path d='M25.8,6.2h-8.3h-5.2H8.8l-1-3.8H4.6C4.3,2.4,4,2.5,3.7,2.8L3.5,3.1c-0.2,0.3,0,0.8,0.4,0.8h2.4l4.3,15.8
                c0.2,0.6,0.7,1,1.3,1h10c0.4,0,0.8-0.3,1-0.6l0.2-0.4c0.1-0.3-0.1-0.6-0.4-0.6H12.2l-0.8-3.6h0.8h10.4h0.6l0.2-0.5c0,0,0,0,0,0
                l3.2-7.5C26.8,6.8,26.4,6.2,25.8,6.2z'
      />
    </g>
  </svg>
)

export default ViewCartIcon
